import styled, { css } from 'styled-components';

export const Wrapper = styled.button`
  all: unset;
  text-decoration: underline;
  display: flex;
  justify-content: center;
  width: 100%;
  cursor: pointer;
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    color: ${theme.colors.navyBlue};
    margin-bottom: ${theme.spacing(3)};
  `}
`;
